<template></template>
<script type="text/babel">

  export default {
    name: 'GoogleMapDirectionsService',
    data() {
      return {
        directionsDisplay: null,
        directionsService: null,
        originMarker: null,
        destinationMarker: null,
      }
    },
    mounted() {
      if (this.$parent.ready) {
        this.init()
      } else {
        this.$parent.$on('map-ready', () => {
          this.init()
        })
      }
    },

    destroyed() {
      this.directionsDisplay.setMap(null);
      this.originMarker.setMap(null);
      this.destinationMarker.setMap(null)
    },
    methods: {
      init: function () {
        if (this.$parent.ready) {
          this.directionsService = new google.maps.DirectionsService;
          this.directionsDisplay = new google.maps.DirectionsRenderer({
            suppressMarkers: true,
            polylineOptions: {strokeColor: this.color},
          });
          this.directionsDisplay.setMap(this.getMap());
          this.directionsDisplay.setOptions({suppressMarkers: true});
          this.directionsService.route({
            origin: this.origin,
            destination: this.destination,
            travelMode: this.travelMode,
          }, (response, status) => {
            if (status === google.maps.DirectionsStatus.OK) {
              this.setDirections(response)
            } else {
              this.$emit('directionsRequestFailed')
            }
          })


        }
      },
      getMap: function () {
        return this.$parent.getMap()
      },
      setDirections(response) {
        this.directionsDisplay.setDirections(response);
        var leg = response.routes[0].legs[0];
        if (this.originMarker !== null) {
          this.originMarker.setMap(null)
        }
        this.originMarker = this.addMarker(leg.start_location, this.iconStart, 'title');
        if (this.destinationMarker !== null) {
          this.destinationMarker.setMap(null)
        }
        this.destinationMarker = this.addMarker(leg.end_location, this.iconEnd, 'title')
      },
      addMarker(latLng, icon) {
        return new google.maps.Marker({
          position: latLng,
          map: this.getMap(),
          title: '[[*pagetitle]]',
          icon: {
            url: icon,
            // This marker is 20 pixels wide by 32 pixels high.
            scaledSize: new google.maps.Size(30, 30), // scaled size
            // The origin for this image is (0, 0).
            origin: new google.maps.Point(0, 0),
            // The anchor for this image is the base of the flagpole at (0, 32).
            anchor: new google.maps.Point(15, 15), // using dimention / 2 we can center the images
          },
        })
      },

    },
    watch: {
      origin: {
        handler() {
          if (this.originMarker && this.destinationMarker) {
            this.directionsDisplay.setMap(null)
            this.originMarker.setMap(null)
            this.destinationMarker.setMap(null)
          }
          this.init()
        },
        deep: true,
      },
      destination: {
        handler() {
          if (this.originMarker && this.destinationMarker) {
            this.directionsDisplay.setMap(null)
            this.originMarker.setMap(null)
            this.destinationMarker.setMap(null)
          }
          this.init()
        },
        deep: true,
      },
    },
    props: {
      origin: {
        type: Object,
        required: true,
      },

      destination: {
        type: Object,
        required: true,
      },
      travelMode: {
        type: String,
        default: 'WALKING',
      },
      color: {
        type: String,
        default: '#FF0000',
      },
      iconStart: {
        default: 'http://maps.google.com/mapfiles/ms/micons/blue.png',
        type: String,
      },
      iconEnd: {
        default: 'http://maps.google.com/mapfiles/ms/micons/green.png',
        type: String,
      },

    },
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// GoogleMapDirectionsService.vue?65b6d2a1